import { checkboxField, dropdownField, tagField } from '@/ui/components/form';
import { t } from '@/ui/i18n/i18n';
import { ComputedRef, Ref } from 'vue';
import { SsoConfiguration } from '@/entities/sso-configuration';
import { Task } from '@/ui/concerns';
import { ValidationError } from '@/entities/validation';
import { SelectOptions } from '@/ui/types';

const convertStringListToOptions = ({ data }: { data: string[] }): SelectOptions<string> => data.map(
  item => ({
    value: item,
    label: item,
  }),
);

export const JitFormFields = (record: Ref<SsoConfiguration>, validationErrors: ComputedRef<ValidationError[]>, task: Task, roleOptions: Ref<SelectOptions>) => {
  return [
    checkboxField(
      {
        name: 'jitProvisioning',
        label: t('sso.jit.enable'),
        tooltipText: t('sso.tooltips.jit-provisioning'),
        value: record.value.jitProvisioning,
        required: true,
        errors: validationErrors.value,
        disabled: task.state.value.pending,
      },
      value => {
        record.value.jitProvisioning = value;
      },
    ),

    record.value.jitProvisioning && [
      tagField(
        {
          name: 'emailDomains',
          label: t('sso.email-domains'),
          tooltipText: t('sso.tooltips.email-domains'),
          value: record.value.emailDomains,
          placeholder: t('sso.email-domains-placeholder'),
          required: false,
          options: convertStringListToOptions({ data: record.value.emailDomains }),
          errors: validationErrors.value,
          disabled: true,
        },
        value => {
          record.value.emailDomains = value || [t('sso.email-domains-empty')];
        },
      ),
      dropdownField(
        {
          name: 'defaultRole',
          label: t('sso.default-role'),
          tooltipText: t('sso.tooltips.default-role'),
          value: record.value.defaultRole,
          placeholder: t('sso.default-role-placeholder'),
          required: false,
          options: roleOptions.value,
          errors: validationErrors.value,
          disabled: task.state.value.pending,
        },
        value => {
          record.value.defaultRole = value || null;
        },
      ),
    ],
  ];
};
